import { createContext, useState } from 'react';

export const ShareModalContext = createContext({
  showShareModal: false,
  selectedCandidate: null,
  selfRequestHandler: null,
  handleSetSelectCandidate: () => {},
  handleShowShareModal: () => {},
  handleCloseShareModal: () => {},
});

export const ShareModalProvider = ({ children }) => {
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  // Optional candidate-self-view request flow. Only the candidate menu passes this; the sponsor
  // menu calls handleShowShareModal() with no args, so it stays null and the sponsor Share window
  // is unchanged.
  const [selfRequestHandler, setSelfRequestHandler] = useState(null);

  const handleSetSelectCandidate = (user) => setSelectedCandidate(user);
  const handleShowShareModal = (options) => {
    setSelfRequestHandler(() => (options && options.selfRequestHandler) || null);
    setShowShareModal(true);
  };
  const handleCloseShareModal = () => {
    setShowShareModal(false);
    setSelfRequestHandler(null);
  };

  return (
    <ShareModalContext.Provider
      value={{
        showShareModal,
        selectedCandidate,
        selfRequestHandler,
        handleSetSelectCandidate,
        handleShowShareModal,
        handleCloseShareModal,
      }}
    >
      {children}
    </ShareModalContext.Provider>
  );
};
